export default __webpack_public_path__ + "static/media/grafema_recta-intencao-book_05.83787019.jpg";